import FakeButton from "../../../Components/FormComponents/FakeButton";
import styles from "./index.module.css";
import CalendarStar from "../ContentBlock/CalendarStar";
import paymentByParts from "./paymentbyparts.png";
import womanWithBook from "./andr.jpg";
import noteIcon from "../LandingBlock/icon.svg";

export default function PriceBlock({ setPopup }) {
  return (
    <section className={styles.bcontainer} id={"price"} data-aos={"fade-up"}>
      <div className={styles.container}>
        <div className={styles.cards}>
          <article className={styles.mediaCard}>
            <img
              className={styles.mediaImage}
              src={womanWithBook}
              alt="Жінка з книгою"
            />
            <div className={styles.mediaShade} />
            <h2>ВАРТІСТЬ</h2>
            <div className={styles.important}>
              <h3>Важливо!</h3>
              <p>
                Абонемент можна оплатити повністю або у два етапи. При оплаті
                повного інтенсива — 25% знижка на speaking clubs на зимовий
                період. Оплата абонементу не повертається.
              </p>
            </div>
          </article>

          <article className={styles.priceCard}>
            <div className={styles.priceHeader}>
              <div>
                <div className={styles.oldPrice}>34 240</div>
                <div className={styles.currentPrice}>
                  <span>28 600</span>
                  <small>грн *</small>
                </div>
              </div>
              <img
                className={styles.paymentBadge}
                src={paymentByParts}
                alt="Оплата частинами"
              />
            </div>

            <div className={styles.features}>
              <div className={styles.feature}>
                <span className={styles.featureIcon}>
                  <CalendarStar />
                </span>
                <span>52 уроки</span>
              </div>
              <div className={styles.feature}>
                <span className={styles.featureIcon}>
                  <CalendarStar />
                </span>
                <span>3 місяці</span>
              </div>
            </div>

            <p className={styles.note}>
              *тобто лише 550 грн за заняття, замість 620 (стандартна ціна
              групового заняття)
            </p>

            <FakeButton blue className={styles.button} onClick={setPopup}>
              Записатись і пройти тест
            </FakeButton>
          </article>
        </div>
      </div>
      <div id={"here"} className={styles.asideContainer}>
        <div className={styles.friendNote}>
          <h3>
            <img
              className={styles.noteIcon}
              src={noteIcon}
              alt=""
              aria-hidden
            />
            До речі!
          </h3>
          <p>
            Якщо ви прийдете на інтенсив разом з другом/подругою, то ми даємо
            вам <strong>10% знижки, кожному!</strong>
          </p>
          <p>
            Щоб записатись разом на інтенсив, напишіть нам в{" "}
            <a href="https://t.me/profoundeng" target="_blank" rel="noreferrer">
              Telegram
            </a>
          </p>
        </div>

        <div className={styles.paymentNotice}>
          <h3>Важливо!</h3>
          <p>
            Навчання на інтенсиві можна оплатити одразу всією сумою, поділити на
            дві оплати або скористатись можливістю оплати трьома частинами у
            Mono. Повна сума має бути сплачена до початку інтенсиву. Оплата
            абонементу не повертається. Група може змінюватись по часу та рівню
            лише за умови, якщо в протилежній групі є такий же запит.
          </p>
        </div>
      </div>
    </section>
  );
}
